$(function () {
	$(document).on('click', '.b-services-popup__arrow-next, .b-services-popup__arrow-prev', function(e) {
		const instance = $.fancybox.getInstance();
		if (this.dataset.action === 'next') {
			instance.next();
		} else if (this.dataset.action === 'prev') {
			instance.previous();
		}
	})
});
